module.exports = __webpack_public_path__ + "static/media/chair.02980098.png";